import type { Ritual } from '../data/ingredients';
import { CATEGORIES } from '../data/ingredients';
import { composeRitual } from '../lib/compose';
import { IngredientStation } from './IngredientStation';
import styles from './Composer.module.css';

interface ComposerProps {
  ritual: Ritual;
  onChange: (next: Ritual) => void;
  onForge: () => void;
}

export function Composer({ ritual, onChange, onForge }: ComposerProps) {
  function setField(key: keyof Ritual, value: string) {
    onChange({ ...ritual, [key]: value });
  }

  const preview = composeRitual(ritual);

  return (
    <div className={styles.layout}>
      <section className={styles.stations}>
        <div className={styles.titleStation}>
          <label htmlFor="ritual-title" className={styles.titleLabel}>
            name (optional)
          </label>
          <input
            id="ritual-title"
            type="text"
            className={styles.titleInput}
            value={ritual.title}
            onChange={(e) => setField('title', e.target.value)}
            placeholder="leave blank for a suggested title"
            maxLength={80}
          />
        </div>

        {CATEGORIES.map((cat) => (
          <IngredientStation
            key={cat.key}
            category={cat}
            ritual={ritual}
            onChange={setField}
          />
        ))}

        <button type="button" className={styles.forge} onClick={onForge}>
          forge the ritual →
        </button>
      </section>

      <aside className={styles.preview} aria-label="live preview">
        <p className={styles.previewLabel}>composing</p>
        <p className={styles.previewBody}>{preview}</p>
      </aside>
    </div>
  );
}
